import useExecuteMutation from "./useExecuteMutation";

export default function useDialogMutation(
  mutationQueries,
  onClose,
  {
    refetchQueries,
    dataMapper,
    fieldsWithPlaceForError = [],
    ...mutationOptions
  },
) {
  const { executeMutation, loading } = useExecuteMutation(mutationQueries, {
    refetchQueries,
    fieldsWithPlaceForError,
    optionsQuery: mutationOptions,
    onSuccessCallback: onClose,
  });

  const handleSubmit = async (data, actions) => {
    const response = await executeMutation(
      dataMapper ? dataMapper(data) : data,
    );
    response?.formErrors && actions.setErrors(response.formErrors);
  };

  return {
    handleSubmit,
    loading,
  };
}
